import { Input } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { ChangeEvent } from 'react';

type Props = {
	name: string;
	label: string;
	value: number | string;
	placeholder?: string;
	required: boolean;
	isError: boolean;
	onChange: (value: string) => void;
	onBlur?: (formattedValue: string) => void; // Add optional onBlur prop
	helperText?: string;
	prefix?: any;
	suffix?: any;
	disabled?: boolean;
	size?: SizeType;
	showLabel?: boolean;
	style?: any;
	isViewOnly?: boolean;
};

const InputShiftHoursField = (props: Props) => {
	const {
		name,
		label,
		value,
		placeholder,
		isError = false,
		prefix = null,
		suffix = null,
		required = false,
		onChange,
		onBlur, 
		disabled = false,
		helperText = 'Invalid field',
		size = 'large',
		showLabel = false,
		style,
		isViewOnly,
	} = props;


	const handleChange = (value: string) => {
		let inputValue = String(value);

		// Remove non-digit characters
		inputValue = inputValue.replace(/\D/g, '');

		// Restrict to 4 digits
		if (inputValue.length > 4) {
			inputValue = inputValue.slice(0, 4);
		}

		// Format inputValue as HH:MM
		if (inputValue.length > 2) {
			inputValue = `${inputValue.slice(0, 2)}:${inputValue.slice(2)}`;
		}

		onChange(inputValue);
	};

	const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;
		let formattedValue = inputValue.replace(/[^\d:]/g, '');

		if (/^\d{1,2}$/.test(formattedValue)) {
			formattedValue = formattedValue.padStart(2, '0') + ':00';
		} else {
			// Handle input with a colon
			const parts = formattedValue.split(':');
			let hours = parts[0] || '00';
			let minutes = parts[1] || '00';

			// Ensure hours and minutes are in two-digit format
			hours = hours.padStart(2, '0');
			minutes = minutes.padEnd(2, '0').slice(0, 2);

			// Combine formatted hours and minutes
			formattedValue = `${hours}:${minutes}`;
		}

		if (formattedValue === '') {
			formattedValue = '00:00';
		}

		// Call onChange with formatted value
		onChange(formattedValue);

		// Trigger additional onBlur logic if provided
		if (onBlur) {
			onBlur(formattedValue);
		}
	};

	return (
		<div className="input-field">
			{showLabel && label && (
				<p
					className="label"
					style={{ marginBottom: `${isViewOnly ? '5px' : ''}` }}
				>
					{label}{' '}
					{required && !isViewOnly && <span className="red">*</span>}
				</p>
			)}

			{isViewOnly ? (
				<p>{value} hrs</p>
			) : (
				<div>
					<Input
						name={name}
						status={isError  ? 'error' : ''}
						placeholder={placeholder}
						prefix={prefix}
						suffix={suffix}
						value={value}
						required={required}
						onChange={(e: any) => {
							handleChange(e.target.value);
						}}
						onBlur={handleBlur}
						disabled={disabled}
						size={size}
						style={{ width: '100%', ...style }}
						maxLength={5} // Enforce max length for HH:MM format
					/>
					{(isError) && (
						<p
							className="red"
							style={{
								fontSize: '12px',
								marginLeft: '2px',
							}}
						>
							{helperText}
						</p>
					)}
				</div>
			)}
		</div>
	);
};

export default InputShiftHoursField;
